export const cifQa = ["301 119","<g fill-rule='nonzero' fill='none'><path fill='#8D1B3D' d='M.5.445h300v118.11H.5z'/><path fill='#FFF' d='M.5.445v118.11h94.488l24.003-6.558-24.003-6.57 24.003-6.558-24.003-6.558 24.003-6.57-24.003-6.558 24.003-6.558-24.003-6.57 24.003-6.558-24.003-6.558 24.003-6.57-24.003-6.558 24.003-6.558-24.003-6.57 24.003-6.558-24.003-6.558 24.003-6.57L94.988.439H.5z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-qa.js
// module id = null
// module chunks = 